export enum SalaryItemDataTypes {
	Numerical = 'Numerical',
	String = 'String',
	Money = 'Money',
	Date = 'Date',
	Time = 'Time'
}

export enum SalaryItemFillTypes {
	Monthly = 'Monthly',
	Yearly = 'Yearly',
	EndYear = 'EndYear',
}

export enum SalaryItemTypes {
	Functional = 'Functional',
	Salary = 'Salary',
	Deductions = 'Deductions',
	Privilege = 'Privilege'
}

export enum SalaryItemActionTypes {
	Single = 'Single',
	Computational = 'Computational',
	Display = 'Display'
}

export enum PersonnelGenderTypes {
	Unknown = 'Unknown',
	Male = 'Male',
	Female = 'Female'
}

export enum PersonnelMarriageTypes {
	Unknown = 'Unknown',
	Single = 'Single',
	Married = 'Married',
	Moayal = 'Moayal'
}

export enum PersonnelMilitaryStatusTypes {
	Unknown = 'Unknown',
	Undone = 'Undone',
	Done = 'Done',
	Exemption = 'Exemption'
}

export enum PersonnelSacrificeStatusTypes {
	NotHaving = 'NotHaving',
	Devotee = 'Devotee',
	MartyrSon = 'MartyrSon',
	ReleasedCaptive = 'ReleasedCaptive',
	ArmedForces = 'ArmedForces',
	Foreigners = 'Foreigners',
	TaxAvoidance = 'TaxAvoidance',
	SubjectEmploymentLaw = 'SubjectEmploymentLaw',
	Razmande12AtLeast = 'Razmande12AtLeast',
	SubjectArticle25 = 'SubjectArticle25'
}

export enum PersonnelEducationalStatusTypes {
	LowDiploma = 'LowDiploma',
	Diploma = 'Diploma',
	AssociateDegree = 'AssociateDegree',
	Bachelors = 'Bachelors',
	Masters = 'Masters',
	Doctorate = 'Doctorate',
	PostDoctoral = 'PostDoctoral'
}

export enum InsuranceTypes {
	NotInsurance = 'NotInsurance',
	Normal = 'Normal',
	UnEmploymentInsurance = 'UnEmploymentInsurance',
	EmployerExemptWithUnEmployee = 'EmployerExemptWithUnEmployee',
	EmployerExemptWithoutUnEmployee = 'EmployerExemptWithoutUnEmployee',
	EmployerAndPersonnelExemptWithUnEmployee = 'EmployerAndPersonnelExemptWithUnEmployee',
	EmployerAndPersonnelExemptWithoutUnEmployee = 'EmployerAndPersonnelExemptWithoutUnEmployee',
	PersonnelExempt = 'PersonnelExempt',
	ArticleOfLaw80_90 = 'ArticleOfLaw80_90',
	ArticleOfLaw80_80 = 'ArticleOfLaw80_80',
	ArticleOfLaw80_70 = 'ArticleOfLaw80_70',
	ArticleOfLaw80_60 = 'ArticleOfLaw80_60',
	ArticleOfLaw80_50 = 'ArticleOfLaw80_50',
	ArticleOfLaw80_40 = 'ArticleOfLaw80_40',
	ArticleOfLaw80_30 = 'ArticleOfLaw80_30',
}

export enum InsuranceBaseTypes {
	HealthService = 'HealthService',
	Tamin = 'Tamin',
	HealthInsurance = 'HealthInsurance',
	Other = 'Other',
	NotHaving = 'NotHaving'
}

export enum PersonnelEmploymentAsTypes {
	Daily = 'Daily',
	Hourly = 'Hourly'
}

export enum PersonnelEmploymentTypes {
	Contractual = 'Contractual',
	Corporate = 'Corporate',
	Official = 'Official',
	Treaty = 'Treaty',
	Agent = 'Agent',
	Fee = 'Fee',
	BuyService = 'BuyService',
	Hourly = 'Hourly',
	Daily = 'Daily',
	OfficialTest = 'OfficialTest',
	SeasonalOfficial = 'SeasonalOfficial',
	Other = 'Other',
}

export enum ContractTypes {
	FullTime = 'FullTime',
	PartTime = 'PartTime',
	Hourly = 'Hourly',
	Treaty = 'Treaty',
	Temporary = 'Temporary'
}

export enum LoanInstallmentStatusTypes {
	Deducted = 'Deducted',
	NotDeducted = 'NotDeducted',
}

export enum SavingBoxTransactionStatusType {
	Decrease = 'Decrease',
	Increase = 'Increase'
}

export enum ExcelTypes {
	InsuranceDBF = 'InsuranceDBF'
}

export enum ExportTypes {
	InsuranceDBF = 'InsuranceDBF',
	FinanceFile = 'FinanceFile'
}


export enum DBFTypes {
	Insurance = 'Insurance',
	Finance = 'Finance'
}

export enum FinancePaymentWays {
	PersonalCheque = 'PersonalCheque',
	CreditCard = 'CreditCard',
	BankTransfer = 'BankTransfer',
	BankDraft = 'BankDraft',
	GuaranteedCheque = 'GuaranteedCheque',
	Cash = 'Cash',
	Treasury = 'Treasury',
	WithoutPayment = 'WithoutPayment'
}

export enum FinanceBankCodes {
	Ansar = 'Ansar',
	ToseeTaavon = 'ToseeTaavon',
	MarkaziIran = 'MarkaziIran',
	Shahr = 'Shahr',
	Dey = 'Dey',
	ToseeSaderatIran = 'ToseeSaderatIran',
	EghtesadNovin = 'EghtesadNovin',
	GharzolhasneMehrIran = 'GharzolhasneMehrIran',
	HekmatIranian = 'HekmatIranian',
	SanatVaMadan = 'SanatVaMadan',
	Karafarin = 'Karafarin',
	Keshavarzi = 'Keshavarzi',
	Maskan = 'Maskan',
	Mellat = 'Mellat',
	MeliIran = 'MeliIran',
	Parsian = 'Parsian',
	Pasargad = 'Pasargad',
	PostBank = 'PostBank',
	RefahKargaran = 'RefahKargaran',
	Saderat = 'Saderat',
	Saman = 'Saman',
	Sarmaye = 'Sarmaye',
	Sepah = 'Sepah',
	Sina = 'Sina',
	Tat = 'Tat',
	Tejarat = 'Tejarat',
	Gardeshgari = 'Gardeshgari',
	Resalat = 'Resalat'
}
export enum MoadianBrokers {
	TaxPanel = 'TaxPanel'
}

export enum FieldExportTypes {
	Sum = 'Sum',
	Count = 'Count'
}

export enum ComprehensiveSalaryReportTypes {
	Workshop = 'Workshop',
	Salary = 'Salary',
	Functional = 'Functional',
	Insurance = 'Insurance',
	Tax = 'Tax',
	Vacation = 'Vacation',
	Checkout = 'Checkout',
	Present = 'Present'
}

export enum DocumentFloatingCenterSelectionTypes {
	Workshop = 'Workshop',
	WorkingPlace = 'WorkingPlace'
}